import config from 'config'
import { load } from 'recaptcha-v3'
import { oauthTokenSelector } from 'selectors/app'
import { doAuthenticateFromToken } from 'actions/auth'
import { doReloadTokenInfo } from 'ducks/tokens/actions'
import grooveAPI from 'api/groove'
import {
  getSignupAccountAttributes,
  getMarketingAttribution,
} from '../../utils'
import { SIGNUP_REQUEST, SIGNUP_SUCCESS, SIGNUP_FAILURE } from '../../types'
import { SHOPIFY_USER_PAGE } from '../pages'

function getReCaptchaToken() {
  return load(config.google_recaptcha_site_key).then(recaptcha =>
    recaptcha.execute('signup')
  )
}

export const doSaveAndRedirect = ({ emailInput, password }) => async (
  dispatch,
  getState
) => {
  const reCaptchaToken = await getReCaptchaToken()
  const state = getState()
  const token = oauthTokenSelector(state)

  const signup = {
    authenticity_token: 'TOKEN',
    recaptcha_token: reCaptchaToken,
    source: 'marketing',
    user: {
      account_attributes: {
        ...getSignupAccountAttributes(),
        type: 'helpdesk',
        onboarding_version: 2,
        billing_provider: 'shopify',
      },
      consents: {
        marketing: true,
        privacy_and_terms: true,
      },
      marketing_attribution: getMarketingAttribution(),
      email: emailInput,
      password,
    },
    utf8: '✓',
  }

  dispatch({
    type: SIGNUP_REQUEST,
    data: { signup },
  })

  try {
    const {
      json,
      json: { account, user },
    } = await grooveAPI.send(
      'post',
      token,
      'users.json',
      {},
      JSON.stringify(signup)
    )
    // HACK (jscheel): Having three dispatches here is terrible, but
    // refactoring how our actions and reducers respond to signups and
    // logins will have to wait for another day.
    dispatch({
      type: SIGNUP_SUCCESS,
      payload: { account, user },
    })
    dispatch(doAuthenticateFromToken(user.token, user.expiresAt))
    dispatch(doReloadTokenInfo())
    dispatch({
      type: SHOPIFY_USER_PAGE,
    })
    return json
  } catch (err) {
    dispatch({
      type: SIGNUP_FAILURE,
      payload: { error: err },
    })
    return err
  }
}
